import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Layers, Paintbrush, ShieldHalf, Droplets, Download } from 'lucide-react';
import { BROCHURE_PDF } from '../data/siteContent';

const items = [
  {
    title: 'Industrial Flooring',
    text: 'Epoxy and Polyurethane based self leveling flooring',
    icon: Layers,
  },
  {
    title: 'Protective / Interior wall coating',
    text: 'Solvent & Water based epoxy & polyurethane coating',
    icon: Paintbrush,
  },
  {
    title: 'Coving',
    text: 'High strength epoxy based coving with polyurethane finish',
    icon: ShieldHalf,
  },
  {
    title: 'Waterproofing system',
    text: 'Acrylic based waterproofing systems for arresting leakages & seepages',
    icon: Droplets,
  },
];

const Services = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <section className="bg-brand-950 py-20 relative overflow-hidden">
        <div className="absolute inset-0 industrial-grid opacity-20" />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center">
          <h1 className="font-heading text-4xl md:text-5xl font-extrabold text-white mb-4">Services</h1>
          <p className="text-neutral-300 max-w-2xl mx-auto">
            Sai Vikas Coatings Pvt. Ltd. offers mainly the following services along with supply of material.
          </p>
        </div>
      </section>
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-8">
            {items.map(({ title, text, icon: Icon }, index) => (
              <div
                key={title}
                className="flex gap-4 p-6 rounded-large border border-neutral-200 bg-neutral-50/50"
              >
                <div className="flex-shrink-0 w-12 h-12 rounded-small bg-brand-100 flex items-center justify-center text-brand-900">
                  <Icon className="w-6 h-6" />
                </div>
                <div>
                  <p className="text-xs font-bold uppercase tracking-wider text-brand-700 mb-1">
                    {index + 1}.
                  </p>
                  <h2 className="font-heading text-lg font-bold text-neutral-900 mb-2">{title}</h2>
                  <p className="text-neutral-600 text-sm leading-relaxed">{text}</p>
                </div>
              </div>
            ))}
          </div>
          <p className="text-center mt-12 flex flex-col items-center justify-center gap-4 sm:flex-row">
            <Link to="/contact" className="inline-flex items-center px-6 py-3 bg-brand-900 text-white font-bold rounded-small hover:bg-brand-800">
              Contact us
            </Link>
            <a
              href={BROCHURE_PDF}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-6 py-3 border-2 border-brand-900 text-brand-900 font-bold rounded-small hover:bg-brand-50"
            >
              <Download className="h-4 w-4" />
              Download brochure
            </a>
          </p>
        </div>
      </section>
    </div>
  );
};

export default Services;
